package com.exura.features.publicplans.domain.api

import kotlinx.serialization.Serializable
import kotlin.js.JsName

@Serializable
@JsName("EnablePublicPlanSharingResponse")
data class EnablePublicPlanSharingResponse(
    @JsName("success")
    val success: Boolean,

    @JsName("message")
    val message: String? = null
)